import { render, staticRenderFns } from "./PurchaseInvoicePreview.vue?vue&type=template&id=61f6605b&scoped=true"
import script from "./PurchaseInvoicePreview.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoicePreview.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInvoicePreview.vue?vue&type=style&index=0&id=61f6605b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6605b",
  null
  
)

export default component.exports